import React from 'react';
import { Container } from 'react-bootstrap';
import {
  FaBuilding,
  FaClipboardCheck,
  FaHome,
  FaIndustry,
  FaSolarPanel,
} from 'react-icons/fa';
import Reveal from './Reveal';

const services = [
  {
    icon: FaHome,
    tag: 'Homes',
    title: 'Domestic electrical work',
    description:
      'Lighting, upgrades, new circuits and general electrical improvements around the home.',
  },
  {
    icon: FaBuilding,
    tag: 'Businesses',
    title: 'Commercial installations',
    description:
      'Electrical work for shops, offices and trading spaces where reliability and presentation both matter.',
  },
  {
    icon: FaIndustry,
    tag: 'Larger spaces',
    title: 'Industrial projects',
    description:
      'Power, lighting and infrastructure for workshops, units and more demanding environments.',
  },
  {
    icon: FaClipboardCheck,
    tag: 'Compliance',
    title: 'Inspection and testing',
    description:
      'Checks, testing and documented electrical work where safety and compliance are the priority.',
  },
  {
    icon: FaSolarPanel,
    tag: 'Energy systems',
    title: 'Solar PV and battery storage',
    description:
      'Solar generation and storage solutions for customers who want smarter control over electricity use.',
  },
];

const AboutSection = () => {
  return (
    <section className="content-section" id="services">
      <Container>
        <Reveal className="section-heading">
          <p className="section-eyebrow">Services</p>
          <h2>What Moonwood Electrical can help with.</h2>
          <p className="section-heading__intro">
            A straightforward range of electrical services for domestic,
            commercial and industrial customers.
          </p>
        </Reveal>

        <div className="service-grid">
          {services.map(({ icon: Icon, tag, title, description }, index) => (
            <Reveal
              as="article"
              className="service-card"
              delay={index * 75}
              key={title}
            >
              <div className="service-card__icon">
                <Icon aria-hidden="true" />
              </div>
              <p className="service-card__tag">{tag}</p>
              <h3>{title}</h3>
              <p>{description}</p>
            </Reveal>
          ))}
        </div>
      </Container>
    </section>
  );
};

export default AboutSection;
